import { render, staticRenderFns } from "./CollectionBox.vue?vue&type=template&id=d2d77c0a&scoped=true"
import script from "./CollectionBox.vue?vue&type=script&lang=js"
export * from "./CollectionBox.vue?vue&type=script&lang=js"
import style0 from "./CollectionBox.vue?vue&type=style&index=0&id=d2d77c0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d77c0a",
  null
  
)

export default component.exports